const WHATSAPP_LINK = 'https://wa.me/905321737544?text=Merhaba,%20Google%20reklam%C4%B1ndan%20ula%C5%9F%C4%B1yorum.%20Ak%C3%BC%20/%20yol%20yard%C4%B1m%20veya%20yedek%20par%C3%A7a%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.';

const services = [
  {
    icon: 'ri-battery-charge-line',
    title: 'Akü Takviye',
    desc: 'Akünüz bittiyse hızlı destek için hemen iletişime geçin.',
  },
  {
    icon: 'ri-exchange-line',
    title: 'Yerinde Akü Değişimi',
    desc: 'Aracınıza uygun akü seçenekleri için WhatsApp’tan bilgi alın.',
  },
  {
    icon: 'ri-roadster-line',
    title: 'Yol Yardım',
    desc: 'Silivri – Tekirdağ hattında yolda kaldığınızda hızlı destek.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Orijinal Yedek Parça',
    desc: 'Aracınıza uygun orijinal yedek parçaları kolayca sorgulayın.',
  },
  {
    icon: 'ri-truck-line',
    title: '81 İle Kargo',
    desc: 'Türkiye’nin 81 iline oto yedek parça gönderimi.',
  },
];

export default function ServiceCards() {
  return (
    <section id="hizmetler" className="relative bg-brand-dark py-20 md:py-28">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white">
            Aracınız İçin Hızlı ve Güvenilir Çözüm
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {services.map((service) => (
            <div
              key={service.title}
              className="group relative bg-brand-surface rounded-2xl p-6 md:p-8 border border-white/10 hover:border-brand-accent/40 transition-all duration-300 hover:-translate-y-1 shadow-lg shadow-black/20"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-white/5 border border-white/10 mb-5 group-hover:border-brand-accent/40 group-hover:bg-brand-accent/10 transition-colors">
                <i className={`${service.icon} text-xl md:text-2xl text-white`}></i>
              </div>

              <h3 className="text-lg md:text-xl font-bold text-white mb-2">
                {service.title}
              </h3>
              <p className="text-sm md:text-base text-brand-muted leading-relaxed mb-5">
                {service.desc}
              </p>

              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-brand-accent hover:bg-brand-accentHover text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors"
              >
                WhatsApp'tan Bilgi Al
                <i className="fas fa-arrow-right text-xs"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}